module.exports = __webpack_public_path__ + "img/8.81a9f57b.jpg";